module.exports = __webpack_public_path__ + "img/code_41656D696C697573.0e42ee62.svg";